// Light touch feedback. In the Capacitor apps this uses the native Haptics plugin;
// on Android browsers it falls back to a 10 ms vibration; elsewhere it does nothing.
type HapticsPlugin = { impact(o: { style: 'LIGHT' | 'MEDIUM' | 'HEAVY' }): Promise<void>; selectionChanged?(): Promise<void> };
declare global { interface Window { Capacitor?: { isNativePlatform?(): boolean; Plugins?: { Haptics?: HapticsPlugin } } } }

function reducedMotion() {
  try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch { return false; }
}

export function haptic(kind: 'tap' | 'select' = 'tap'): void {
  if (reducedMotion()) return;
  const h = window.Capacitor?.Plugins?.Haptics;
  if (h) {
    (kind === 'select' && h.selectionChanged ? h.selectionChanged() : h.impact({ style: 'LIGHT' })).catch(() => {});
    return;
  }
  try { navigator.vibrate?.(kind === 'select' ? 6 : 10); } catch { /* not supported */ }
}

/** True inside the installed app (Capacitor) or a home-screen PWA. */
export function isInstalledApp(): boolean {
  try {
    return !!window.Capacitor?.isNativePlatform?.() || window.matchMedia('(display-mode: standalone)').matches;
  } catch { return false; }
}
